import { CssBaseline } from "@mui/material";
import React from "react";
import { Banner } from "../../../components";
import { ExecutiveContent } from "../aboutElements";

const bannerProps = {
  title: "About Us",
  otherTitle: "Executive Council",
};

const ExecutiveCouncil = () => {
  return (
    <>
      <CssBaseline />
      <Banner {...bannerProps} />
      <ExecutiveContent />
    </>
  );
};

export default ExecutiveCouncil;
